<template>
  <router-link
    class="detail-button"
    :to= this.link
  >
    Detail
  </router-link>
</template>

<script>
export default {
  props: {
    link: Object,
  },
};
</script>

<style scoped>
.detail-button {
  display: block;
  text-decoration: none;
  color: #000;
  max-width: 80px;
  margin: auto;
  padding: 10px;
  border: 2px solid #AAAFB6;
  border-radius: 20px;
  cursor: pointer;
  transition:.2s;
  user-select: none;
}

.detail-button:hover {
  color: #fff;
  background:#AAAFB6;
}

</style>
